export const REPORT_FILTERS_MAPPING = {
  AcademicIndexScore: 'Academic Index',
  AcademicInterestCategory: 'Academic Interest',
  ACTScoreDescription: 'ACT Range',
  AdmitMonth: 'Admit Month',
  ApplicationMonth: 'Application Month',
  ApplicationType: 'Application Type',
  CampusName: 'Campus',
  Cohort: 'Cohort',
  CohortFilter: 'Cohort',
  'Campus Visit': 'Campus Visit',
  BrandLoyalistCategory: 'Brand Loyalty',
  ConsumerIncomeCategory: 'Consumer Income',
  ConsumerPrizmRating: 'Consumer Rating',
  'Consumer Prizm Rating': 'Consumer Rating',
  DecisionType: 'Decision Type',
  DepositMonth: 'Deposit Month',
  DirectAdmission: 'Direct Admission',
  EntryTermYear: 'Entry Term Year',
  EthnicityDetail: 'Ethnicity Detail',
  Ethnicity: 'Ethnicity',
  Sex: 'Sex',
  GPARangeDescription: 'GPA Range',
  InquiryMonth: 'Inquiry Month',
  InquirySource: 'Inquiry Source',
  InquiryClassYear: 'Inquiry Class Year',
  InState: 'In-State',
  International: 'International',
  ProspectSource: 'Prospect Source',
  ProspectSubcategory: 'Prospect Subcategory',
  ProspectClassYear: 'Prospect Class Year',
  ReligionCategory: 'Religion Category',
  SATScoreDescription: 'SAT Range',
  State: 'State',
  StateFullName: 'State',
  CollegeBoardRegion: 'Region',
} as const satisfies Record<string, string>;

export type ReportFilterColumn = keyof typeof REPORT_FILTERS_MAPPING;

export const getFilterDisplayName = (
  filterColumn: string | null | undefined,
): string =>
  (filterColumn &&
    REPORT_FILTERS_MAPPING[filterColumn as ReportFilterColumn]) ||
  filterColumn ||
  'Filter';
